<template>
  <div class="searchbar">
    <div>
      <ul>
        <li>Trier par :</li>
        <li>
          <form class="m-t-10" role="form">
            <div class="form-group form-group-default form-group-default-select2 selection-class">
              <label>Groupes</label>
              <select class=" full-width dropdown-multiselect" multiple>
                <option value="ABC">ABC+</option>
                <option value="SDM">SDM</option>
                <option value="Sofradom">Sofradom</option>
              </select>
            </div>
          </form>
        </li>
        <li>
          <form class="m-t-10" role="form">
            <div class="form-group form-group-default form-group-default-select2 selection-class">
              <label>Agences</label>
              <select class=" full-width dropdown-multiselect" multiple>
                <option value="opera">Agence Opéra</option>
                <option value="bastille">Agence Bastille</option>
                <option value="montreuil">Agence Montreuil</option>
              </select>
            </div>
          </form>
        </li>
        <li>
          <form class="m-t-10" role="form">
            <div class="form-group form-group-default form-group-default-select2" style="width:120px;">
              <label class="">Disponibilité</label>
              <select class="full-width dropdown-select">
                <option value="" disabled selected></option>
                <option value="AK">Disponible</option>
                <option value="HI">Occupée</option>
              </select>
            </div>
            </form>
        </li>
      </ul>
      <ul>
        <li class="checkbox check-complete">
          <input type="checkbox" id="cbox1" value="reserved">
          <label for="cbox1">Réservé</label>
        </li>
        <li class="checkbox check-complete">
          <input type="checkbox" id="cbox2" value="admin-locked">
          <label for="cbox2">Blocage admin</label>
        </li>
        <li class="checkbox check-complete">
          <input type="checkbox" id="cbox3" value="punctual">
          <label for="cbox3">Ponctuelle</label>
        </li>
      </ul>
    </div>
    <button class="btn btn-complete btn-cons">Ajouter une location</button>
  </div>
</template>

<style lang="scss" scoped>
  .searchbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
    padding-top: 10px;
    div {
      display: flex;
      flex-wrap: wrap;
      ul {
        padding: 0;
        margin: 0;
        display: flex;
        align-items: center;
        li {
          display: inline-block;
          list-style-type: none;
          margin-right: 5px;
        }
      }
    }
    button {
      min-width: 150px;
    }
  }
  .selection-class {
    min-width: 100px;
  }
</style>

<script type="text/babel">
  export default {
    mounted () {
      $('.dropdown-multiselect').select2()
      $('.dropdown-select').select2({
        minimumResultsForSearch: -1
      })
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/LongTermLocationsList/SearchBar.vue